import React from "react";
import { connect } from "react-redux";
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import axios from "axios";
import { MdAddBox } from "react-icons/md";
import API from "../helpers/api";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
//import Autocomplete from "react-autocomplete";
import { getEquipmentNameList } from "../Actions/helpersAPI";
import { getPortAndCountry } from "../Actions/ServiceProviderAPI";
import {
  getZoneList,
  getVendorList,
  getSearchVendorOptionsList,
} from "../Actions/VendorManagementAPI";
import { Button, Popover, PopoverHeader, PopoverBody } from "reactstrap";

class VendorZoneTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchData: {
        VendorName: "",
        Equipment: "",
        Zone: "",
        country: "",
        port: "",
        PageNumber: 1,
        PageSize: 20,
      },
      openPort: false,
      openCountry: false,
      VendorPopover: false,
      ZonePopover: false,
      CountryPopover: false,
      openEquipment: false,
      PortPopover: false,
      openPopover: "",
      openVendorPopover: "",
      openPortPopover: "",
      openCountryPopover: "",
      Vendors_List: [],
      Applicable_Services_List: [],
      isView: false,
      selectedCountry: [],
      selectedPort: [],
      selectedEquipment: [],
      selectedVendor: [],
    };
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  async componentDidMount() {
    const { dispatch, match } = this.props;
    dispatch({
      type: "SubBannerTitle",
      data: "Vendor Zone List",
    });
    this.state.searchData.Zone = localStorage.getItem("ZoneName");
    this.GetVendorList(this.state.searchData);
    window.addEventListener("resize", this.resize.bind(this));

    this.resize();
  }
  resize = () => {
    if (window.innerWidth > 987) {
      this.setState({
        isView: true,
      });
    } else {
      this.setState({
        isView: false,
      });
    }
  };
  submitRequest = (item) => {
    const { dispatch } = this.props;
    if (item === "Equipment") {
      this.state.openPopover = "true";
    } else if (item === "Vendor") {
      this.state.openVendorPopover = "true";
    } else if (item === "Country") {
      this.state.openCountryPopover = "true";
    } else if (item === "Port") {
      this.state.openPortPopover = "true";
    }
    this.state.searchData.port = this.state.selectedPort.join(",");
    this.state.searchData.country = this.state.selectedCountry.join(",");
    this.state.searchData.Equipment = this.state.selectedEquipment.join(",");
    this.state.searchData.VendorName = this.state.selectedVendor.join(",");
    this.setState({});
    this.GetVendorList(this.state.searchData);
    dispatch(getEquipmentNameList());
  };

  GetVendorList = (item) => {
    const { dispatch } = this.props;
    let URL = `${API.getVendorList}?EquipmentName=${item.Equipment}&VendorName=${item.VendorName}&PortName=${item.port}&CountryName=${item.country}&Zone=${item.Zone}&PageNumber=${item.PageNumber}&PageSize=${item.PageSize}`;
    axios({
      method: "GET",
      url: URL,
    })
      .then((response) => {
        if (response?.status === 200) {
          this.setState({
            Vendors_List:
              response.data.data.length === 0 ? [] : response.data.data,
          });
          if (this.state.openPopover === "true") {
            this.setState({
              ZonePopover: !this.state.ZonePopover,
            });
          }
          if (this.state.openCountryPopover === "true") {
            this.setState({
              CountryPopover: !this.state.CountryPopover,
            });
          }
          if (this.state.openPortPopover === "true") {
            this.setState({
              PortPopover: !this.state.PortPopover,
            });
          }
          if (this.state.openVendorPopover === "true") {
            this.setState({
              VendorPopover: !this.state.VendorPopover,
            });
          }
          dispatch(getPortAndCountry(this.state.searchData));
          dispatch(getSearchVendorOptionsList(this.state.searchData));
          dispatch(getZoneList());
          dispatch(getEquipmentNameList());
          this.state.openPopover = "";
          this.state.openCountryPopover = "";
          this.state.openVendorPopover = "";
          this.state.openPortPopover = "";
          this.setState({});
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
        }
      });
  };
  handleSelectChange(value, field) {
    if (field === "country") {
      this.state.searchData[field] = value;
      this.setState({}, () => {
        console.log(this.state.searchData);
      });
      this.props.dispatch(getPortAndCountry(this.state.searchData));
    }
    this.state.searchData[field] = value;
    this.setState({}, () => {
      console.log(this.state.searchData);
    });
  }
  renderCountryTitle(state, val) {
    return state?.toLowerCase().indexOf(val?.toLowerCase()) !== -1;
  }
  renderPortTitle(state, val) {
    return state?.port?.toLowerCase().indexOf(val?.toLowerCase()) !== -1;
  }
  renderEquipmentTitle(state, val) {
    return (
      state?.equipmentName?.toLowerCase().indexOf(val?.toLowerCase()) !== -1
    );
  }

  hideSidePanel() {
    const { dispatch, history } = this.props;
    history.push(`/Home/VendorManagement`);
  }
  EquipmentClearInput(item) {
    if (item === "Equipment") {
      this.state.openPopover = "true";
    }
    this.state.searchData.Equipment = "";
    this.state.selectedEquipment = [];
    this.setState({});
    this.GetVendorList(this.state.searchData);
  }
  CountryClearInput(item) {
    if (item === "Country") {
      this.state.openCountryPopover = "true";
    }
    this.state.searchData.country = "";
    this.state.selectedCountry = [];
    this.setState({});
    this.GetVendorList(this.state.searchData);
  }
  PortClearInput(item) {
    if (item === "Port") {
      this.state.openPortPopover = "true";
    }
    this.state.searchData.port = "";
    this.state.selectedPort = [];
    this.setState({});
    this.GetVendorList(this.state.searchData);
  }
  VendorClearInput(item) {
    if (item === "Vendor") {
      this.state.openVendorPopover = "true";
    }
    this.state.searchData.VendorName = "";
    this.state.selectedVendor = [];
    this.setState({});
    this.GetVendorList(this.state.searchData);
  }

  render() {
    const {} = this.state;
    return <div className="pb-3">{this.renderCardData()}</div>;
  }

  handleInputChange(e, field) {
    this.state.searchData[field] = e.target.value;
    this.setState({});
  }

  Vendortoggle = (item) => {
    if(this.state.ZonePopover){
      this.state.ZonePopover=!this.state.ZonePopover;
      this.setState({})
    }
    if(this.state.CountryPopover){
      this.state.CountryPopover=!this.state.CountryPopover;
      this.setState({})
    }if(this.state.PortPopover){
      this.state.PortPopover=!this.state.PortPopover;
      this.setState({})
    }
    if (item) {
      this.setState({
        VendorPopover: !this.state.VendorPopover,
      });
    }
  };
  Equipmenttoggle = (item) => {
    if(this.state.VendorPopover){
      this.state.VendorPopover=!this.state.VendorPopover;
      this.setState({})
    }
    if(this.state.CountryPopover){
      this.state.CountryPopover=!this.state.CountryPopover;
      this.setState({})
    }if(this.state.PortPopover){
      this.state.PortPopover=!this.state.PortPopover;
      this.setState({})
    }
    if (item) {
      this.setState({
        ZonePopover: !this.state.ZonePopover,
      });
    }
  };
  Contrytoggle = (item) => {
    if(this.state.VendorPopover){
      this.state.VendorPopover=!this.state.VendorPopover;
      this.setState({})
    }
  if(this.state.PortPopover){
    this.state.PortPopover=!this.state.PortPopover;
    this.setState({})
  }
  if(this.state.ZonePopover){
    this.state.ZonePopover=!this.state.ZonePopover;
    this.setState({})
  }
    if (item) {
      this.setState({
        CountryPopover: !this.state.CountryPopover,
      });
    }
  };
  Porttoggle = (item) => {
    if(this.state.ZonePopover){
      this.state.ZonePopover=!this.state.ZonePopover;
      this.setState({})
    }
    if(this.state.VendorPopover){
      this.state.VendorPopover=!this.state.VendorPopover;
      this.setState({})
    }
    if(this.state.CountryPopover){
      this.state.CountryPopover=!this.state.CountryPopover;
      this.setState({})
    }
    if (item) {
      this.setState({
        PortPopover: !this.state.PortPopover,
      });
    }
  };
onEquipmentChange = (event, values) => {
    this.setState(
      {
        selectedEquipment: values,
      },
      () => {
        console.log(this.state.selectedEquipment);
        this.Equipmenttoggle(false);
      }
    );
  };
  onVendorChange = (event, values) => {
    this.setState(
      {
        selectedVendor: values,
      },
      () => {
        console.log(this.state.selectedVendor);
        this.Vendortoggle(false)
      }
    );
  };
  onContryChange = (event, values) => {
    this.setState(
      {
        selectedCountry: values,
      },
      () => {
        console.log(this.state.selectedCountry);
        this.Contrytoggle(false)
      }
    );
  };

  onPortChange = (event, values) => {
    this.setState(
      {
        selectedPort: values,
      },
      () => {
        console.log(this.state.selectedPort);
        this.Porttoggle(false);
      }
    );
  };
  ClearAllFilter() {
    if(this.state.VendorPopover){
      this.state.VendorPopover=!this.state.VendorPopover;
      this.setState({})
    }
    if(this.state.ZonePopover){
      this.state.ZonePopover=!this.state.ZonePopover;
      this.setState({})
    }
    if(this.state.CountryPopover){
      this.state.CountryPopover=!this.state.CountryPopover;
      this.setState({})
    }if(this.state.PortPopover){
      this.state.PortPopover=!this.state.PortPopover;
      this.setState({})
    }
    this.state.searchData.Equipment = "";
    this.state.searchData.country = "";
    this.state.searchData.port = "";
    this.state.searchData.VendorName = "";
    this.state.selectedPort = [];
    this.state.selectedCountry = [];
    this.state.selectedEquipment = [];
    this.state.selectedVendor = [];
    this.setState({});
    this.GetVendorList(this.state.searchData);
  }
  NewitemNav = () => {
    let Id= localStorage.getItem("ZoneNameId");
    localStorage.setItem("EditZoneNameId", Id);
    localStorage.setItem("EditVendorName", "");
    localStorage.setItem("EditEquipmentName", "");
    localStorage.setItem("EditEquipmentNameId", "");
    this.props.dispatch({ type: "NewZoneDetailsAdd", data: true });
     this.props.dispatch({ type: "NewVendorDetailsAdd", data: false });
     this.props.dispatch({ type: "NewEquipmentDetailsAdd", data: false });
     this.props.history.push("/Home/VendorManagementNewItem");
   };

  renderCardData() {
    const {
      VendorList,
      VendorEquipmentName,
      zoneList,
      Loading,
      PortList,
      VendorSearchEquipmentList,
      VendorSearchVendorsList,
      VendorSearchCountryList,
      VendorSearchPortList,
      VendorSearchZoneList,
      VendorCountryList,
      EquipmentNameList,
      t
    } = this.props;
    const { Vendors_List, Applicable_Services_List } = this.state;

    return (
      <div className="full-height">
        <div className="row mt-2">
          <button
            className="btn btn-primary text-uppercase txtside-btn txtht-btn blue m-2 ml-3"
            onClick={() => this.hideSidePanel()}
          >
            &larr; {t("CommonText.Back")}
          </button>
          <div className="col-lg-12 mt-2">
            <div className="row resource-list-auth-date">
              <div className="col-lg-12">
                <div className="panel-box search-filter-box">
                <div className="pt-2">
                  <span className="mt-1">
                    <strong style={{ fontSize: "larger" }}> {t("VendorManagementScreenContent.ZoneName")} : </strong>
                    <span className="lato">
                      {" "}
                      {this.state.searchData?.Zone}{" "}
                    </span>
                  </span>
                  <div className="m-1 flex" style={{ float: "right" }}>
                      <span className="mt-1">{t("VendorManagementScreenContent.AddVendor")}</span>
                      <MdAddBox
                        className="px-1 click"
                        style={{
                          color: "#1a3464",
                          fontSize: "2.3rem",
                          marginTop:"-5px"
                        }}
                        onClick={this.NewitemNav}
                      />
                    </div>
                    </div>
                  <div
                    className="card MM-card-header mb-0 mt-3"
                    style={{ backgroundColor: "white" }}
                  >
                    <div
                      className="card-body flex"
                      style={{
                        padding: "0rem",
                        backgroundColor: "#1a3464",
                        color: "white",
                      }}
                    >
                      <h5
                        className="card-title ml-2 mt-2"
                        style={{ color: "092a51" }}
                      >
                        {t("VendorManagementScreenContent.VendorZoneDetails")}
                      </h5>
                    </div>
                  </div>
                  <div className="pt-2">
                    <div className="col-lg-12 col-sm-12 col-md-12">
                      <div className="px-3">
                        {" "}
                        <a
                          type="button"
                          class="btn btn-link click"
                          onClick={() => this.ClearAllFilter()}
                          style={{ color: "#007bff",float:"right" }}
                        >
                          {t("VendorManagementScreenContent.ClearFilter")}
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="search-filter-box">
                    <div className="row px-4">
                      <div className="col-12 px-4 pt-2 mt-1">
                        <div
                          className={`${
                            window.innerWidth < 1000
                              ? ""
                              : this.state.isView === false
                              ? "table-container2"
                              : "table-vendor-container1"
                          } table-responsive`}
                          style={{ width: "100%" }}
                        >
                          <table id="tableview" className="table cellborder">
                            <tbody>
                              <tr className="border">
                                <td
                                  className={`${
                                    window.innerWidth < 1000
                                      ? "border-left"
                                      : "sl-no"
                                  } border-right border-left vendor-width equipment-color`}
                                >
                                  {" "}
                                  {t("ShipEquipmentStatusScreen.EquipmentName")}{" "}
                                  <i
                                    class="fa fa-filter filter-style"
                                    id={`popover0`}
                                    style={{ cursor: "pointer" }}
                                    aria-hidden="true"
                                  ></i>
                                  <Popover
                                    placement="right"
                                    trigger="click"
                                    isOpen={this.state.ZonePopover}
                                    target={`popover0`}
                                    toggle={() => this.Equipmenttoggle(true)}
                                  >
                                    <PopoverHeader>
                                    {t("VendorManagementScreenContent.EquipmentSearch")}
                                    </PopoverHeader>
                                    <PopoverBody>
                                      <div className="row">
                                        <div className="col-12 col-sm-12 my-1">
                                          <label className="form-label">
                                          {t("ShipEquipmentStatusScreen.Equipment")}
                                          </label>
                                          <br></br>
                                          <Autocomplete
                                            multiple
                                            value={this.state.selectedEquipment}
                                            options={VendorSearchEquipmentList??[]}
                                            onChange={this.onEquipmentChange}
                                            filterSelectedOptions
                                            renderInput={(params) => (
                                              <TextField
                                                {...params}
                                                placeholder={t("EquipmentManagementScreenContent.SelectEquipment")}
                                                margin="normal"
                                              />
                                            )}
                                          />
                                        </div>
                                        <div
                                          className="col-12 mt-1"
                                          style={{ textAlign: "right" }}
                                        >
                                          <div className="btn-group">
                                            <Button
                                              className="btn btn-primary button-border btn-xs mt-2"
                                              size="sm"
                                              onClick={() =>
                                                this.submitRequest("Equipment")
                                              }
                                            >
                                            {t("content.Search")}
                                            </Button>
                                            <Button
                                              className="btn btn-primary button-border btn-xs mt-2 ml-3"
                                              size="sm"
                                              onClick={() =>
                                                this.EquipmentClearInput(
                                                  "Equipment"
                                                )
                                              }
                                            >
                                            {t("content.Clear")}
                                            </Button>
                                          </div>
                                        </div>
                                      </div>
                                    </PopoverBody>
                                  </Popover>
                                </td>
                                {this.state.Vendors_List.length !== 0 ? (
                                  this.state.Vendors_List.map((j) => (
                                    <td
                                      className="border-right border-top vendor-body-width border-left align-middle spanTopBar"
                                      style={{ textAlign: "center" }}
                                      colSpan={j?.applicableZones.map(
                                        (k) => k.applicableVendors?.length
                                      )}
                                    >
                                      <span className="spanTopBar">
                                        {j?.equipmentName}
                                      </span>
                                    </td>
                                  ))
                                ) : (
                                  <td
                                    className="border-right border-left border-top border-bottom text-center align-middle"
                                    colSpan={11}
                                    rowSpan={8}
                                  >
                                    <span className="spandoc-td">
                                    {t("CommonText.NoMatchingItem")}
                                    </span>
                                  </td>
                                )}
                              </tr>
                              <tr className="border">
                                <td
                                  className={`${
                                    window.innerWidth < 1000
                                      ? "border-left"
                                      : "sl-no"
                                  } border-right border-left border-top border-bottom vendor-width equipment-color`}
                                >
                                  {t("EquipmentSeviceDetailsScreen.ServiceYear")}
                                </td>
                                {this.state.Vendors_List?.map((i) =>
                                  i.applicableZones?.map((j) =>
                                    j.zoneServices?.map((k) => (
                                      <td
                                        className="border-right border-top border-bottom vendor-body1-width border-left align-middle spanTopBar"
                                        style={{ textAlign: "center" }}
                                        colSpan={
                                          j.applicableVendors.filter(
                                            (item) => item.serviceYear === k
                                          ).length
                                        }
                                      >
                                        <span className="spanTopBar">{k}</span>
                                      </td>
                                    ))
                                  )
                                )}
                              </tr>
                              <tr className="border">
                                <td
                                  className={`${
                                    window.innerWidth < 1000
                                      ? "border-left"
                                      : "sl-no"
                                  } 
                                border-right border-left vendor-width equipment-color`}
                                >
                                   {t("VendorManagementScreenContent.VendorName")}{" "}
                                  <i
                                    class="fa fa-filter filter-style"
                                    id={`popover1`}
                                    style={{ cursor: "pointer" }}
                                    aria-hidden="true"
                                  ></i>
                                  <Popover
                                    placement="right"
                                    trigger="click"
                                    isOpen={this.state.VendorPopover}
                                    target={`popover1`}
                                    toggle={() => this.Vendortoggle(true)}
                                  >
                                    <PopoverHeader>{t("VendorManagementScreenContent.VendorSearch")}</PopoverHeader>
                                    <PopoverBody>
                                      <div className="row">
                                        <div className="col-12 col-sm-12 my-1">
                                          <label className="form-label">
                                          {t("VendorManagementScreenContent.Vendor")}
                                          </label>
                                          <br></br>
                                          <Autocomplete
                                            multiple
                                            value={this.state.selectedVendor}
                                            options={VendorSearchVendorsList??[]}
                                            onChange={this.onVendorChange}
                                            filterSelectedOptions
                                            renderInput={(params) => (
                                              <TextField
                                                {...params}
                                                placeholder={t("VendorManagementScreenContent.SelectVendor")}
                                                margin="normal"
                                              />
                                            )}
                                          />
                                        </div>
                                        <div
                                          className="col-12 mt-1"
                                          style={{ textAlign: "right" }}
                                        >
                                          <div className="btn-group">
                                            <Button
                                              className="btn btn-primary button-border btn-xs mt-2"
                                              size="sm"
                                              onClick={() =>
                                                this.submitRequest("Vendor")
                                              }
                                            >
                                              {t("content.Search")}
                                            </Button>
                                            <Button
                                              className="btn btn-primary button-border btn-xs mt-2 ml-3"
                                              size="sm"
                                              onClick={() =>
                                                this.VendorClearInput("Vendor")
                                              }
                                            >
                                              {t("content.Clear")}
                                            </Button>
                                          </div>
                                        </div>
                                      </div>
                                    </PopoverBody>
                                  </Popover>
                                </td>

                                {this.state.Vendors_List?.map((i) =>
                                  i.applicableZones?.map((j) =>
                                    j.zoneServices?.map((k) =>
                                      j.applicableVendors
                                        .filter(
                                          (item) => item.serviceYear === k
                                        )
                                        .map((l) => (
                                          <td
                                            className="border-right border-top vendor-body1-width border-left align-middle spanTopBar break-text"
                                            style={{ textAlign: "center" }}
                                          >
                                            <span className="spanTopBar">
                                              {l.vendorName || "-"}
                                            </span>
                                          </td>
                                        ))
                                    )
                                  )
                                )}
                              </tr>
                              <tr className="border">
                                <td
                                  className={`${
                                    window.innerWidth < 1000
                                      ? "border-left"
                                      : "sl-no"
                                  } 
                                 border-right border-left vendor-width equipment-color`}
                                >
                                  {" "}
                                  {t("TopPaneContent.Unit")}{" "}
                                </td>
                                {this.state.Vendors_List?.map((i) =>
                                  i.applicableZones?.map((j) =>
                                    j.zoneServices?.map((k) =>
                                      j.applicableVendors
                                        .filter(
                                          (item) => item.serviceYear === k
                                        )
                                        .map((l) => (
                                          <td
                                            className="border-right border-top vendor-body1-width border-left align-middle spanTopBar"
                                            style={{ textAlign: "center" }}
                                          >
                                            <span className="spanTopBar">
                                              {l?.unitName ? l?.unitName : "-"}
                                            </span>
                                          </td>
                                        ))
                                    )
                                  )
                                )}
                              </tr>
                              <tr className="border">
                                <td
                                  className={`${
                                    window.innerWidth < 1000
                                      ? "border-left"
                                      : "sl-no"
                                  } 
                                border-right border-left vendor-width equipment-color`}
                                >
                                 {t("ShipEquipmentStatusScreen.Quantity")}
                                </td>
                                {this.state.Vendors_List?.map((i) =>
                                  i.applicableZones?.map((j) =>
                                    j.zoneServices?.map((k) =>
                                      j.applicableVendors
                                        .filter(
                                          (item) => item.serviceYear === k
                                        )
                                        .map((l) => (
                                          <td
                                            className="border-right border-top vendor-body1-width border-left align-middle spanTopBar"
                                            style={{ textAlign: "center" }}
                                          >
                                            <span className="spanTopBar">
                                              {l?.quantity ? l?.quantity : "-"}
                                            </span>
                                          </td>
                                        ))
                                    )
                                  )
                                )}
                              </tr>
                              <tr className="border">
                                <td
                                  className={`${
                                    window.innerWidth < 1000
                                      ? "border-left"
                                      : "sl-no"
                                  } 
                                border-right border-left vendor-width equipment-color`}
                                >
                                  {t("EquipmentServiceTypes.Country")}
                                  <i
                                    class="fa fa-filter filter-style"
                                    id={`popover2`}
                                    style={{ cursor: "pointer" }}
                                    aria-hidden="true"
                                  ></i>
                                  <Popover
                                    placement="right"
                                    trigger="click"
                                    isOpen={this.state.CountryPopover}
                                    target={`popover2`}
                                    toggle={() => this.Contrytoggle(true)}
                                  >
                                    <PopoverHeader>
                                    {t("VendorManagementScreenContent.CountrySearch")}
                                    </PopoverHeader>
                                    <PopoverBody>
                                      <div className="row">
                                        <div className="col-12 col-sm-12 my-1">
                                          <label className="form-label">
                                          {t("EquipmentServiceTypes.Country")}
                                          </label>
                                          <br></br>
                                          <Autocomplete
                                            multiple
                                            value={this.state.selectedCountry}
                                            options={VendorSearchCountryList??[]}
                                            onChange={this.onContryChange}
                                            filterSelectedOptions
                                            renderInput={(params) => (
                                              <TextField
                                                {...params}
                                                placeholder={t("VendorManagementScreenContent.SelectCountry")}
                                                margin="normal"
                                              />
                                            )}
                                          />
                                        </div>
                                        <div
                                          className="col-12 mt-1"
                                          style={{ textAlign: "right" }}
                                        >
                                          <div className="btn-group">
                                            <Button
                                              className="btn btn-primary button-border btn-xs mt-2"
                                              size="sm"
                                              onClick={() =>
                                                this.submitRequest("Country")
                                              }
                                            >
                                             {t("content.Search")} 
                                            </Button>
                                            <Button
                                              className="btn btn-primary button-border btn-xs mt-2 ml-3"
                                              size="sm"
                                              onClick={() =>
                                                this.CountryClearInput(
                                                  "Country"
                                                )
                                              }
                                            >
                                              {t("content.Clear")}
                                            </Button>
                                          </div>
                                        </div>
                                      </div>
                                    </PopoverBody>
                                  </Popover>
                                </td>
                                {this.state.Vendors_List?.map((i) =>
                                  i.applicableZones?.map((j) =>
                                    j.zoneServices?.map((k) =>
                                      j.applicableVendors
                                        .filter(
                                          (item) => item.serviceYear === k
                                        )
                                        .map((l) => (
                                          <td
                                            className="border-right border-top vendor-body1-width border-left align-middle spanTopBar"
                                            style={{ textAlign: "center" }}
                                          >
                                            <span className="spanTopBar">
                                              {l?.countryName
                                                ? l?.countryName
                                                : "-"}
                                            </span>
                                          </td>
                                        ))
                                    )
                                  )
                                )}
                              </tr>
                              <tr className="border">
                                <td
                                  className={`${
                                    window.innerWidth < 1000
                                      ? "border-left"
                                      : "sl-no"
                                  } 
                                border-right border-top border-left vendor-width equipment-color`}
                                >
                                  {t("TopPaneContent.Port")}
                                  <i
                                    class="fa fa-filter filter-style"
                                    style={{ cursor: "pointer" }}
                                    id={`popover3`}
                                    aria-hidden="true"
                                  ></i>
                                  <Popover
                                    placement="right"
                                    trigger="click"
                                    isOpen={this.state.PortPopover}
                                    target={`popover3`}
                                    toggle={() => this.Porttoggle(true)}
                                  >
                                    <PopoverHeader>{t("VendorManagementScreenContent.PortSearch")}</PopoverHeader>
                                    <PopoverBody>
                                      <div className="row">
                                        <div className="col-12 col-sm-12 my-1">
                                          <label className="form-label">
                                          {t("TopPaneContent.Port")}
                                          </label>
                                          <br></br>
                                          <Autocomplete
                                            multiple
                                            value={this.state.selectedPort}
                                            options={VendorSearchPortList??[]}
                                            onChange={this.onPortChange}
                                            filterSelectedOptions
                                            renderInput={(params) => (
                                              <TextField
                                                {...params}
                                                placeholder={t("VendorManagementScreenContent.SelectPort")}
                                                margin="normal"
                                              />
                                            )}
                                          />
                                        </div>
                                        <div
                                          className="col-12 mt-1"
                                          style={{ textAlign: "right" }}
                                        >
                                          <div className="btn-group">
                                            <Button
                                              className="btn btn-primary button-border btn-xs mt-2"
                                              size="sm"
                                              onClick={() =>
                                                this.submitRequest("Port")
                                              }
                                            >
                                            {t("content.Search")}
                                            </Button>
                                            <Button
                                              className="btn btn-primary button-border btn-xs mt-2 ml-3"
                                              size="sm"
                                              onClick={() =>
                                                this.PortClearInput("Port")
                                              }
                                            >
                                            {t("content.Clear")}
                                            </Button>
                                          </div>
                                        </div>
                                      </div>
                                    </PopoverBody>
                                  </Popover>
                                </td>
                                {this.state.Vendors_List?.map((i) =>
                                  i.applicableZones?.map((j) =>
                                    j.zoneServices?.map((k) =>
                                      j.applicableVendors
                                        .filter(
                                          (item) => item.serviceYear === k
                                        )
                                        .map((l) => (
                                          <td
                                            className="border-right border-top vendor-body1-width border-left align-middle spanTopBar"
                                            style={{ textAlign: "center" }}
                                          >
                                            <span className="spanTopBar">
                                              {l?.portName ? l?.portName : "-"}
                                            </span>
                                          </td>
                                        ))
                                    )
                                  )
                                )}
                              </tr>
                              <tr className="border">
                                <td
                                  className={`${
                                    window.innerWidth < 1000
                                      ? "border-left"
                                      : "sl-no"
                                  } border-right border-left vendor-width border-top border-bottom equipment-color`}
                                >
                                 {t("VendorManagementScreenContent.Price")}
                                </td>
                                {this.state.Vendors_List?.map((i) =>
                                  i.applicableZones?.map((j) =>
                                    j.zoneServices?.map((k) =>
                                      j.applicableVendors
                                        .filter(
                                          (item) => item.serviceYear === k
                                        )
                                        .map((l) => (
                                          <td
                                            className="border-right border-top border-bottom vendor-body1-width border-left align-middle spanTopBar"
                                            style={{ textAlign: "center" }}
                                          >
                                            <span className="spanTopBar">
                                              {l?.price ? l.price : "-"}
                                            </span>
                                          </td>
                                        ))
                                    )
                                  )
                                )}
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    VendorSearchEquipmentList:
      state.VendorManagementReducer.VendorSearchEquipmentList,
    VendorSearchVendorsList:
      state.VendorManagementReducer.VendorSearchVendorsList,
    VendorSearchCountryList:
      state.VendorManagementReducer.VendorSearchCountryList,
    VendorSearchPortList: state.VendorManagementReducer.VendorSearchPortList,
    VendorSearchZoneList: state.VendorManagementReducer.VendorSearchZoneList,
    zoneList: state.VendorManagementReducer.zoneList,
    VendorList: state.VendorManagementReducer.VendorApplicableList,
    VendorEquipmentName: state.SidePanReducer.VendorEquipmentName,
    EquipmentNameList: state.MasterScreenReducer.EquipmentNameList || [],
    PortList: state.MasterScreenReducer.PortLists || [],
    Loading: state.PageLoaderReducer.loading,
    VendorCountryList: state.VendorManagementReducer.VendorCountryList || [],
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(VendorZoneTable));
